/** @module csi/view/customview/SetAsDefaultController */
define([
	"dojo/_base/declare",
	"csi",
	"csi/action/Controller",
	"csi/sessionConstants",
	"./_DefaultControllerMixin"
], function(declare,csi,Controller,sessionConstants,_DefaultControllerMixin) {

	return declare([Controller, _DefaultControllerMixin], {
		/**
		 * Write operations to save selected custom view as default.
		 */
		// TODO: need to implement logic for multiple roles
		toWriter: function() {
			const urlRole = sessionConstants.roleUrl;
			const cv = this.widget.getSelectedCustomView();
			const urlParty = cv.isSharedWithRole(urlRole) ? urlRole : csi.EMPTY_URL;
			this._writeDefault(cv.urlNode, urlParty);
		},

		/**
		 * Update custom view store when default changes - could be that the OOTB default view no longer needs to be shown.
		 */
		postProcessSuccess: function() {
			this.widget.onChangeDefaultCustomView();
		}
	});
});